import { z } from 'zod';

import { KitPriceAdjustmentTypeSchema } from './kit.schemas.js';

export const UpdateKitBodySchema = z
  .object({
    name: z.string().trim().min(1).max(255).optional(),
    sku: z.string().trim().max(50).nullable().optional(),
    categoryId: z.uuid().nullable().optional(),
    internalNotes: z.string().trim().max(5000).nullable().optional(),
    priceAdjustmentType: KitPriceAdjustmentTypeSchema.optional(),
    priceAdjustmentValue: z
      .string()
      .regex(/^-?\d+$/)
      .optional(),
  })
  .refine((body) => Object.keys(body).length > 0, { message: 'At least one field is required' });

export const UpdateKitResponseSchema = z.object({
  kitId: z.uuid(),
  changedFields: z.array(z.string()),
});

export type UpdateKitBody = z.infer<typeof UpdateKitBodySchema>;
export type UpdateKitResponse = z.infer<typeof UpdateKitResponseSchema>;
